/**
 * Serializer from / to JSON
 */
export class JSONSerializer {
  /**
   * Converts a value to the string
   *
   * @param {*} value
   *
   * @returns {string | null}
   */
  static serialize(value) {
    try {
      return value == null ? null : JSON.stringify(value)
    } catch (error) {
      console.error('JSONSerializer.serialize:', error)

      return null
    }
  }

  /**
   * Converts string value to an object
   *
   * @param {string | null} value
   *
   * @returns {* | null}
   */
  static deserialize(value) {
    try {
      return value == null ? null : JSON.parse(value)
    } catch (error) {
      console.error('JSONSerializer.deserialize:', error)

      return null
    }
  }
}
